import { CrmFieldResponse, CrmGuidResponse, CrmResponse, LookupResponse, PicklistResponse } from 'common/interfaces';
import { ReactNode } from 'react';

export interface ItemProps {
  annualMileage: number;
  engineType: {
    value: number;
    name: string;
  };
  events: EventProps[];
  fuelConsumption: number;
  isEco: boolean;
  kraftstoffcosten_value: number;
  kraftstoffcosten: number;
  kraftstoffcostenPlusGesamtrate: number;
  uds_calc_monthly_costs_incl_fuel_value: number;
  new_listenpreis_netto_value: number;
  new_listenpreis_brutto_value: number;
  leasingPeriod: number;
  modifiedon: string;
  uds_name: string;
  new_status_anfrage_value: number;
  new_status_anfrage_id: number;
  new_stromverbrauch: number;
  sharepointLocation: string;
  tags: any[];
  uds_ausstattungshighlights_shortlist: string;
  uds_bafa: boolean;
  uds_carBrandName: string;
  uds_carModelName: string;
  uds_co2_emission_combined: number;
  uds_color: string;
  uds_comprehensive_insurance: number;
  uds_engine_tax: number;
  uds_enginetypecode: string;
  uds_enginetypecode_value: number;
  uds_fahrzeugangeboteid: string;
  uds_finanzrate: number;
  uds_fuelconsumption_out_of_city: string;
  uds_fuelconsumption_urban: string;
  uds_getriebe: number;
  uds_getriebe_value: number;
  uds_gez_fee: number;
  uds_gezgebhrcheckbox: boolean;
  uds_hauptauto: boolean;
  uds_interiorcolor: string;
  uds_internalid: string;
  uds_kalkulatorischekraftstoffkosten_value: number;
  uds_kfzsteuercheckbox: boolean;
  uds_kommentar_des_haendlers: string;
  uds_lastModified: string;
  uds_laufleistungkm: number;
  uds_laufleistungpafahrzeugangebote: number;
  uds_laufzeitfahrzeugangebote: number;
  uds_leistung: string;
  uds_leistungkw: number;
  uds_listenpreis: number;
  uds_listenpreis_value: number;
  uds_listenpreis_netto: number;
  uds_listenpreis_netto_value: number;
  uds_maintenance_cost: number;
  uds_marge: number;
  uds_marke: string;
  uds_mobexo_contribution: number;
  uds_mobexo_gesamtrate: number;
  uds_mobexo_gesamtrate_value: number;
  uds_mobexoangebotgesamtrate: number;
  uds_modell: string;
  uds_reifenersatzcheckbox: boolean;
  uds_tire_replacement_cost: number;
  uds_title: string;
  uds_uds_fuelconsumption_combined: string;
  uds_vollkaskoversicherungcheckbox: boolean;
  uds_vsl_liefertermin_laut_handler: string;
  uds_vsl_liefertermin_laut_handler_main: string;
  uds_wartunginspektioncheckbox: boolean;
  uds_wheels_storage_cost: number;
  uds_winterrderinkllagerungcheckbox: boolean;
  uds_wunschlieferdatum: string;
  uds_wunschlaufzeitcode_value: string;
  uds_einmaligekosten_uberfuhrungskosten_value: number;
  uds_einmaligekosten_zulassungskosten_value: number;
  uds_einmaligekosten_anzahlung_value: number;
  uds_barpreis_netto_value: number;
  la_listenpreis_netto_value: number;
  la_barpreis_netto_value: number;
  includeFuelCosts: boolean;
  uds_gesamtkosten_monatlich_vertragsabschluss_value: number;
  uds_kalkulatorischekraftstoffkosten: number;
  uds_haendlerkontakt_id: string;
  uds_anbietenterhandlerid_id: string;
  uds_anbietenterhandlerid: string;
  uds_global_reference_vehicleid_id: string;
  uds_angebotsstatuscode_value: number;
  uds_tags: string;
  lowestLeasingprice_value: number;
  uds_zuordnung_value: number;
  canBeArchived: boolean;
  uds_remove_request_date: string;
  uds_configurationtypecode_value: number;
  carPolicyList: { uds_carpolicyid: CrmGuidResponse; uds_name: CrmResponse }[];
}

export interface ItemPropsBase {
  canBeArchived: boolean;
  includeFuelCosts: boolean;
  isEco: boolean;
  kraftstoffcosten: number;
  kraftstoffcosten_value: number;
  kraftstoffcostenPlusGesamtrate: number;
  modifiedon: CrmFieldResponse<PicklistResponse<string, string>>;
  new_status_anfrage: CrmFieldResponse<PicklistResponse>;
  new_stromverbrauch: CrmFieldResponse<number>;
  uds_altes_fahrzeugid: CrmFieldResponse<LookupResponse>;
  uds_bafa: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_barpreis_netto: CrmFieldResponse<PicklistResponse>;
  uds_carbrandid: CrmFieldResponse<LookupResponse>;
  uds_carmodelid: CrmFieldResponse<LookupResponse>;
  uds_co2_efficiencycode: CrmFieldResponse<PicklistResponse>;
  uds_co2_emission_combined: CrmFieldResponse<number>;
  uds_color: CrmFieldResponse;
  uds_comprehensive_insurance: CrmFieldResponse<PicklistResponse>;
  uds_configurationtypecode: CrmFieldResponse<PicklistResponse>;
  uds_emissioncategorycode: CrmFieldResponse<PicklistResponse>;
  uds_engine_tax: CrmFieldResponse<PicklistResponse>;
  uds_enginetypecode: CrmFieldResponse<PicklistResponse>;
  uds_fahrzeugangeboteid: string;
  uds_finanzrate: CrmFieldResponse<number>;
  uds_fuelconsumption_out_of_city: CrmFieldResponse;
  uds_fuelconsumption_urban: CrmFieldResponse<PicklistResponse>;
  uds_getriebe: CrmFieldResponse<PicklistResponse>;
  uds_gesamtkosten_monatlich_vertragsabschluss: CrmFieldResponse<PicklistResponse>;
  uds_gez_fee: CrmFieldResponse<PicklistResponse>;
  uds_gezgebhrcheckbox: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_global_reference_vehicleid: CrmFieldResponse<LookupResponse>;
  uds_hauptauto: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_highesteventtypeid: CrmFieldResponse<LookupResponse>;
  uds_interiorcolor: CrmFieldResponse;
  uds_internalid: CrmFieldResponse;
  uds_kalkulatorischekraftstoffkosten: CrmFieldResponse<PicklistResponse>;
  uds_kfzsteuercheckbox: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_kstverantw: CrmFieldResponse<LookupResponse>;
  uds_laufleistungkm: CrmFieldResponse<number>;
  uds_laufzeit: CrmFieldResponse<number>;
  uds_leistung: CrmFieldResponse<number>;
  uds_leistungkw: CrmFieldResponse<number>;
  uds_listenpreis: CrmFieldResponse<PicklistResponse>;
  uds_listenpreis_netto: CrmFieldResponse<PicklistResponse>;
  uds_maintenance_cost: CrmFieldResponse<PicklistResponse>;
  uds_marge: CrmFieldResponse<number>;
  uds_marke: CrmFieldResponse;
  uds_mobexo_contribution: CrmFieldResponse<PicklistResponse>;
  uds_mobexo_gesamtrate: CrmFieldResponse<PicklistResponse>;
  uds_modell: CrmFieldResponse;
  uds_modellspezifikation: CrmFieldResponse;
  uds_name: CrmFieldResponse;
  uds_reifenersatzcheckbox: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_remove_request_date: CrmFieldResponse<PicklistResponse<string, string>>;
  uds_tags: CrmFieldResponse;
  uds_tire_replacement_cost: CrmFieldResponse<PicklistResponse>;
  uds_title: CrmFieldResponse;
  uds_trim_level: CrmFieldResponse;
  uds_uds_fuelconsumption_combined: CrmFieldResponse;
  uds_vollkaskoversicherungcheckbox: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_vsl_liefertermin_laut_handler: CrmFieldResponse<PicklistResponse<string, string>>;
  uds_vsl_liefertermin_laut_handler_main: CrmFieldResponse<PicklistResponse<string, string>>;
  uds_wartunginspektioncheckbox: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_wheels_storage_cost: CrmFieldResponse<number>;
  uds_winterrderinkllagerungcheckbox: CrmFieldResponse<PicklistResponse<string, boolean>>;
  uds_wunschlieferdatum: CrmFieldResponse<PicklistResponse<string, string>>;
  uds_zuordnung: CrmFieldResponse<PicklistResponse>;
  sharepointLocation: string;
  freigeber: CrmFieldResponse<LookupResponse>;
  globalFaConfigurationType: CrmFieldResponse<PicklistResponse>;
}

export interface ItemPropsResponse extends ItemPropsBase {
  events: { attributes: EventProps }[];
  carPolicyList: { attributes: { uds_carpolicyid: string; uds_name: CrmFieldResponse } }[];
}

export interface ItemPropsForList extends ItemPropsBase {
  events: EventProps[];
  carPolicyList: { uds_carpolicyid: string; uds_name: CrmFieldResponse }[];
}

export interface DateInfoProps {
  icon: ReactNode;
  title: string;
  value: string;
}

export interface TriangleProps {
  width: number;
  height: number;
  color: string;
  rotate?: number;
}

export interface InfoItemProps {
  children?: string;
}

export interface ProductInfoProps {
  label: ReactNode;
  value: string;
}

export interface ProductProps {
  reloadList: (deactivateCar?: boolean) => void;
  setUseQueryKey: () => any;
  item: ItemPropsForList;
}

export interface RoleProps {
  id: string;
  name: string;
}

export interface EventProps {
  createdon: PicklistResponse<string, string>;
  uds_erstelltfurid: CrmFieldResponse<LookupResponse>;
  uds_erstelltvonportaluser: CrmFieldResponse<LookupResponse>;
  uds_eventdescription: CrmFieldResponse<LookupResponse>;
  uds_fahrzeugangebotid: CrmFieldResponse<LookupResponse>;
  uds_fahrzeugbestellfreigeberid: CrmFieldResponse<LookupResponse>;
  uds_fahrzeugbestellungeneventsid: string;
  uds_name: CrmFieldResponse;
  uds_notiz: CrmFieldResponse;
  uds_portal_user_accountid: CrmFieldResponse<LookupResponse>;
}

export enum DriverWireframeIds {
  Dr01 = 'T-DR-01',
  Dr02 = 'T-DR-02',
  Dr03 = 'T-DR-03'
}

export enum FleetManagerWireframeIds {
  Fm01 = 'T-FM-01',
  Fm02 = 'T-FM-02',
  Fm03 = 'T-FM-03',
  Fm04 = 'T-FM-04',
  Fm05 = 'T-FM-05',
  Fm06 = 'T-FM-06',
  Fm07 = 'T-FM-07',
  Fm08 = 'T-FM-08'
}
